<ng-template #template>
  <div class="col-12 p-lg-0">
    <div class="card validate-resp hgs">
      <img class="card-img" src="{{ logoImage }}" alt="" aria-hidden="true" />
      <div class="card-img-overlay align-items-center d-flex">
        <div class="row w-100">
          <div class="col-6 col-md-5 offset-1 offset-md-2">
            <div
              class="card-title h1-eq"
              *ngIf="!preventValidation && !decisionReadonly"
              style="line-height: 1"
            >
              {{ texts?.areYouReadyText }}
            </div>
            <div
              class="card-title h1-eq"
              *ngIf="!preventValidation && decisionReadonly && canRelease"
              style="line-height: 1"
            >
              {{ texts?.wantReleaseDecisionText }}
            </div>
            <div
              class="card-title h1-eq"
              *ngIf="!preventValidation && decisionReadonly && !canRelease"
              style="line-height: 1"
            >
              {{ texts?.decisionIsValidatedText }}
            </div>
            <div
              class="card-title h1-eq"
              *ngIf="preventValidation"
              style="line-height: 1"
            >
              {{ texts.cashAtEndCannotBeNegative }}
            </div>
            <div class="card-text h3-eq"></div>
          </div>
          <div class="col-5 col-md-4 offset-md-1 align-items-center d-flex">
            <button
              type="button"
              class="btn btn-validate align-items-center d-flex text-uppercase"
              *ngIf="!decisionReadonly || canRelease"
              (click)="onclick()"
              style="color: black"
              [ngClass]="{ disabled: preventValidation }"
            >
              <span [hidden]="isDemo || decisionReadonly">{{
                texts?.sendDecisionText
              }}</span>
              <span [hidden]="isDemo || !decisionReadonly || !canRelease">{{
                texts?.releaseDecisionText
              }}</span>
              <span [hidden]="!isDemo">{{ texts?.runDecisionText }}</span>

              &nbsp;&nbsp;<img src="img/arrow-right.svg" width="24" height="24"
                alt="" aria-hidden="true"
            /></button>
            <span
              *ngIf="status"
              style="top: 70px; position: absolute; left: 130px"
              >{{ status }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
